export default class AdwordsGoogleSearch {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }
  async getGoogleSearch(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate,
    customerId
  ) {
    const googleSearch = await this.axios.get(
      `${process.env.VUE_APP_API_BASE_URL_GOOGLE}/adwords/SEARCH/${customerId}/businesses/${businessUnitId}?fromDate=${fromDate}&toDate=${toDate}`
    );

    const metrics = { ...googleSearch.data };
    // Empty campaign responses omit some of the detailed report fields.
    for (const field of [
      "campaigns",
      "campaignsLocation",
      "conversionActions",
      "phoneCall",
      "impressionsAndClicks",
      "keywords",
      "ages",
      "genders",
      "devices",
      "ads"
    ]) {
      metrics[field] = Array.isArray(metrics[field]) ? metrics[field] : [];
    }
    for (const field of [
      "totalImpressions",
      "totalClicks",
      "totalCtr",
      "totalCpc",
      "totalCpm"
    ]) {
      metrics[field] = Number.isFinite(metrics[field]) ? metrics[field] : 0;
    }
    return metrics;
  }

  // PAGES
  async getGoogleSearchPages(subscriberId, businessUnitId, fromDate, toDate) {
    try {
      const googleSearch = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/google-analytics/summary-pages/business/${businessUnitId}/${subscriberId}?toDate=${toDate}&fromDate=${fromDate}`
      );

      return {
        ...googleSearch.data
      };
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
      return {};
    }
  }
}
